package com.iregained.eventapp.components.models

import kotlinx.serialization.Serializable

@Serializable
data class TimeSlotData(
    val slotId: String = "2026-09-15_0900",
    val date: String = "2026-09-15",
    val startTime: String = "09:00",
    val endTime: String = "10:00",
    val capacity: Int = 16,
    val bookedCount: Int = 4,
    val isBlocked: Boolean = false
)